import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RumButtonComponent } from './rum-button/rum-button.component';
import { RumWrapperContainerComponent } from './rum-wrapper-container/rum-wrapper-container.component';
import { FormWrapperComponent } from './form-wrapper/form-wrapper.component';
import { AuthWrapperComponent } from './auth-wrapper/auth-wrapper.component';
import { ImportBtnComponent } from './import-btn/import-btn.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MegaMenuModule } from 'primeng/megamenu';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { MenubarModule } from 'primeng/menubar';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { SpeedDialModule } from 'primeng/speeddial';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PaginatorModule } from 'primeng/paginator';
import { ToastModule } from 'primeng/toast';
import { TreeSelectModule } from 'primeng/treeselect';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CardModule } from 'primeng/card';
import { CalendarModule } from 'primeng/calendar';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { CheckboxModule } from 'primeng/checkbox';
import { ImageModule } from 'primeng/image';
import { PasswordModule as PrimeNgPasswordModule } from 'primeng/password';
import { DividerModule } from 'primeng/divider';
import { DialogModule } from 'primeng/dialog';
import { TreeTableModule } from 'primeng/treetable';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { MessageService } from 'primeng/api';
import { ChartModule } from 'primeng/chart';
import { SelectButtonModule } from 'primeng/selectbutton';
import { FieldsetModule } from 'primeng/fieldset';
import { ColorPickerModule } from 'primeng/colorpicker';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TooltipModule } from 'primeng/tooltip';
import { DragDropModule } from 'primeng/dragdrop';
import { MultiSelectModule } from 'primeng/multiselect';
import { SplitButtonModule } from 'primeng/splitbutton';
import { SkeletonModule } from 'primeng/skeleton';
import { InputSwitchModule } from 'primeng/inputswitch';
import { RippleModule } from 'primeng/ripple';
import { FileUploadModule } from 'primeng/fileupload';
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import {SidebarModule} from "primeng/sidebar";
import {PanelMenuModule} from "primeng/panelmenu";
import {AccordionModule} from "primeng/accordion";
import {BadgeModule} from "primeng/badge";
import {MenuModule} from "primeng/menu";
import {TabViewModule} from "primeng/tabview";
import {ScrollPanelModule} from "primeng/scrollpanel";
import {ChipModule} from "primeng/chip";
import {ChipsModule} from "primeng/chips";
import {EllipsePipe} from "../../pipes/ellipses/ellipse.pipe";
import { PowerBIEmbedModule } from 'powerbi-client-angular';
import {DateAgoPipe} from "../../pipes/dateAgo/date-ago.pipe";
import { SidebarLayoutComponent } from './layout/sidebar-layout/sidebar-layout.component';
import {RouterModule} from "@angular/router";
import {AclDirective} from "../../directives/acl.directive";
import {OverlayPanelModule} from "primeng/overlaypanel";
import {InputTextareaModule} from "primeng/inputtextarea";
import {StyleClassModule} from "primeng/styleclass";
import { HotTableModule } from '@handsontable/angular';
import { registerAllModules } from 'handsontable/registry';

registerAllModules();

@NgModule({
  declarations: [
    RumButtonComponent,
    RumWrapperContainerComponent,
    FormWrapperComponent,
    AuthWrapperComponent,
    ImportBtnComponent,
    EllipsePipe,
    DateAgoPipe,
    SidebarLayoutComponent,
    AclDirective,
  ],
  imports: [CommonModule,RouterModule, FileUploadModule, HotTableModule],
  exports: [
    RumButtonComponent,
    StyleClassModule,
    RumWrapperContainerComponent,
    FormWrapperComponent,
    AuthWrapperComponent,
    MegaMenuModule,
    InputTextModule,
    ButtonModule,
    MenubarModule,
    ScrollPanelModule,
    ChipModule,
    ChipsModule,
    AvatarModule,
    AvatarGroupModule,
    DropdownModule,
    TableModule,
    SpeedDialModule,
    ConfirmDialogModule,
    PaginatorModule,
    ToastModule,
    TreeSelectModule,
    ProgressBarModule,
    ProgressSpinnerModule,
    CardModule,
    FormsModule,
    CalendarModule,
    ReactiveFormsModule,
    BreadcrumbModule,
    CheckboxModule,
    ImageModule,
    PrimeNgPasswordModule,
    DividerModule,
    DialogModule,
    TreeTableModule,
    ChartModule,
    SelectButtonModule,
    FieldsetModule,
    ColorPickerModule,
    AutoCompleteModule,
    RadioButtonModule,
    TooltipModule,
    DragDropModule,
    MultiSelectModule,
    SplitButtonModule,
    SkeletonModule,
    InputSwitchModule,
    RippleModule,
    InfiniteScrollModule,
    ImportBtnComponent,
    SidebarModule,
    PanelMenuModule,
    AccordionModule,
    BadgeModule,
    MenuModule,
    TabViewModule,
    FileUploadModule,
    EllipsePipe,
    PowerBIEmbedModule,
    DateAgoPipe,
    SidebarLayoutComponent,
    AclDirective,
    OverlayPanelModule,
    InputTextareaModule,
    HotTableModule
  ],
  providers: [MessageService, DatePipe,AclDirective],
})
export class SharedModule {}
